var map = {
	"./basic.vue": "D5vj",
	"./default.vue": "m1ms"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "clTk";


//////////////////
// WEBPACK FOOTER
// ./resources/js/layouts nonrecursive .*\.vue$
// module id = clTk
// module chunks = 32